/**
 * Quality tier for standard evaluations: quality indicator (condition level) + group code + descriptor.
 * Used to group evaluation text variants on inventory detail.
 */

export function buildEvaluationTierKey(conditionLevel: number, groupCode: string | undefined, groupCodeDescriptor: string | undefined): string {
    const gc = (groupCode || '').trim();
    const gcd = (groupCodeDescriptor || '').trim();
    return `${conditionLevel}::${gc}::${gcd}`;
}

/** Display: "{X} - {GC} - {GCD}" per product spec */
export function formatEvaluationTierLabel(conditionLevel: number, groupCode: string | undefined, groupCodeDescriptor: string | undefined): string {
    const gc = (groupCode || '').trim() ? (groupCode || '').trim() : '—';
    const gcd = (groupCodeDescriptor || '').trim() ? (groupCodeDescriptor || '').trim() : '—';
    return `${conditionLevel} - ${gc} - ${gcd}`;
}



// WEBPACK FOOTER //
// ./src/common/evaluation-quality-tier.ts